import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';
import { ConfirmComponent } from './confirm.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
    ],
    exports: [ ConfirmComponent ],
    declarations: [ ConfirmComponent ],
    entryComponents: [ ConfirmComponent ],
})
export class ConfirmModule {}
